// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3qHmz","content":"styles_content__Jkj29","checkbox":"styles_checkbox__xMiaJ","checkboxLabel":"styles_checkboxLabel__2X_9g"};